var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { staticClass: "person-modal__form" }, [
    _c("div", { staticClass: "row gutter-lg items-start" }, [
      _c("div", { staticClass: "col-sm-auto col-12 gt-xs" }, [
        _c(
          "div",
          {
            staticClass: "bg-grey-1 circle text-center q-mr-lg",
            staticStyle: {
              height: "125px",
              width: "125px",
              "line-height": "125px"
            }
          },
          [
            _c("q-icon", {
              staticClass: "bg-grey-1 circle",
              attrs: { name: "person", color: "grey-3", size: "100px" }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-sm col-12" }, [
        _c("div", { staticClass: "row gutter-sm" }, [
          _c(
            "div",
            { staticClass: "col-sm-6 col-12" },
            [
              _c("salutation-field", {
                staticClass: "full-width",
                model: {
                  value: _vm.formData.salutation,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "salutation", $$v)
                  },
                  expression: "formData.salutation"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row gutter-sm" }, [
          _c(
            "div",
            { staticClass: "col-sm-6 col-12" },
            [
              _c(
                "q-field",
                {
                  staticClass: "col-sm-6 col-12",
                  attrs: {
                    error: _vm.errors.has("title"),
                    "error-label": _vm.errors.first("title")
                  }
                },
                [
                  _c("q-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "min:1|max:255",
                        expression: "'min:1|max:255'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: {
                      name: "title",
                      placeholder: _vm.$t("title"),
                      required: ""
                    },
                    model: {
                      value: _vm.formData.title,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "title", $$v)
                      },
                      expression: "formData.title"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "row gutter-x-sm" },
          [
            _c(
              "q-field",
              {
                staticClass: "col-sm-6 col-12",
                attrs: {
                  error: _vm.errors.has("firstName"),
                  "error-label": _vm.errors.first("firstName")
                }
              },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "max:255",
                      expression: "'max:255'",
                      modifiers: { disable: true }
                    }
                  ],
                  ref: "firstName",
                  attrs: {
                    name: "firstName",
                    placeholder: _vm.$t("person_first_name"),
                    required: ""
                  },
                  model: {
                    value: _vm.formData.firstName,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "firstName", $$v)
                    },
                    expression: "formData.firstName"
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "col-sm-6 col-12",
                attrs: {
                  error: _vm.errors.has("lastName"),
                  "error-label": _vm.errors.first("lastName")
                }
              },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required|min:1|max:255",
                      expression: "'required|min:1|max:255'",
                      modifiers: { disable: true }
                    }
                  ],
                  attrs: {
                    name: "lastName",
                    placeholder: _vm.$t("person_last_name"),
                    required: ""
                  },
                  model: {
                    value: _vm.formData.lastName,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "lastName", $$v)
                    },
                    expression: "formData.lastName"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "row q-mt-md" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("multi-email-input", {
                attrs: { "hide-label": "", "show-icon": "", label: "" },
                model: {
                  value: _vm.formData.emailAddresses,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "emailAddresses", $$v)
                  },
                  expression: "formData.emailAddresses"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row q-mt-md" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("multi-phone-input", {
                attrs: { "hide-label": "", "show-icon": "", label: "" },
                model: {
                  value: _vm.formData.phoneNumbers,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "phoneNumbers", $$v)
                  },
                  expression: "formData.phoneNumbers"
                }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }